const hiddenDropTrailerFlagColumns = [
  'dropped_dc',
  'loaded_dc',
  'picked_up_dc',
  'dropped_pool',
  'pool_offload_started',
  'pool_offload_finished',
  'pool_scanning_started',
  'pool_scanning_finished',
  'pars_sent',
  'carrier_confirmation_sent',
  'appointment_plus_appointment_made',
  'appointment_plus_unload_time_set',
  'notification_trailer_empty',
  'drop_trailer_status_note',
];

export const dropTrailerDefaultGridState = {
  "sideBar": {
    "visible": true,
    "position": "right",
    "openToolPanel": null,
    "toolPanels": {
      "columns": {
        "expandedGroupIds": []
      },
      "filters": {
        "expandedGroupIds": [],
        "expandedColIds": []
      }
    }
  },
  "columnVisibility": {
    "hiddenColIds": hiddenDropTrailerFlagColumns
  },
  "columnSizing": {
    "columnSizingModel": [
      { "colId": "work_order_details", "width": 52 },
      { "colId": "alternate_reference", "width": 138 },
      { "colId": "booking_number", "width": 140 },
      { "colId": "carrier_name", "width": 190 },
      { "colId": "carrier_trailer", "width": 132 },
      { "colId": "drop_trailer_flow", "width": 270 },
      { "colId": "drop_trailer_admin_flags", "width": 520 },
      { "colId": "lading_notes", "width": 260 },
      { "colId": "shipper_name", "width": 190 },
      { "colId": "consignee_name", "width": 220 },
      { "colId": "consignee_locality", "width": 150 },
      { "colId": "lading_number", "width": 140 },
      { "colId": "pickup_reference_number", "width": 124 },
      { "colId": "load_pieces", "width": 112 },
      { "colId": "load_start", "width": 138 },
      { "colId": "appointment_date", "width": 138 },
      { "colId": "appointment_window", "width": 178 },
      { "colId": "current_drop_status", "width": 154 },
      { "colId": "interline_carrier_name", "width": 190 },
      { "colId": "lading_id", "width": 126 },
      ...hiddenDropTrailerFlagColumns.map((colId) => ({ colId, width: 132 }))
    ]
  },
  "columnPinning": {
    "leftColIds": [
      "work_order_details",
      "alternate_reference",
      "booking_number",
      "carrier_name",
      "carrier_trailer",
      "drop_trailer_flow"
    ],
    "rightColIds": []
  },
  "columnOrder": {
    "orderedColIds": [
      "work_order_details",
      "alternate_reference",
      "booking_number",
      "carrier_name",
      "carrier_trailer",
      "drop_trailer_flow",
      "drop_trailer_admin_flags",
      "lading_notes",
      "shipper_name",
      "consignee_name",
      "consignee_locality",
      "lading_number",
      "pickup_reference_number",
      "load_pieces",
      "load_start",
      "appointment_date",
      "appointment_window",
      "current_drop_status",
      "interline_carrier_name",
      "lading_id",
      ...hiddenDropTrailerFlagColumns
    ]
  }
};
